import { createContext } from "react";

const ConsentContentContext = createContext();

export default ConsentContentContext;